"use strict";

require("core-js/modules/es6.array.for-each");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./utils");

var Container =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2["default"])(Container, _React$Component);

  function Container() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Container.prototype;

  _proto.render = function render() {
    var _classNames;

    var _this$props = this.props,
        className = _this$props.className,
        _this$props$children = _this$props.children,
        children = _this$props$children === void 0 ? [] : _this$props$children,
        classPrefix = _this$props.classPrefix,
        props = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["className", "children", "classPrefix"]);
    var addPrefix = (0, _utils.prefix)(classPrefix);
    var hasSidebar = false;
    React.Children.forEach(children, function (item) {
      if ((0, _get2["default"])(item, 'type.displayName') === 'Sidebar') {
        hasSidebar = true;
      }
    });
    var classes = (0, _classnames["default"])(classPrefix, className, (_classNames = {}, _classNames[addPrefix('has-sidebar')] = hasSidebar, _classNames));
    return React.createElement("div", (0, _extends2["default"])({}, props, {
      className: classes
    }), children);
  };

  return Container;
}(React.Component);

(0, _defineProperty2["default"])(Container, "handledProps", ["children", "className", "classPrefix"]);

var _default = (0, _utils.defaultProps)({
  classPrefix: 'container'
})(Container);

exports["default"] = _default;